module.exports = __webpack_public_path__ + "img/frame-test-s.246c8e86.png";